<template>
   <wgu-module-card v-bind="$attrs"
      moduleName="wgu-layerlist"
      class="wgu-layerlist"
      :icon="icon"
      :closable="false"
      >
      <wgu-layerlist
        :showLegends="showLegends"
        :showOpacityControls="showOpacityControls"
        :openAtLaunchLayers="openAtLaunchLayers"
      />
   </wgu-module-card>
</template>

<script>
import ModuleCard from '../modulecore/ModuleCard';
import LayerList from './LayerList';

export default {
  name: 'wgu-layerlist-win',
  inheritAttrs: false,
  components: {
    'wgu-module-card': ModuleCard,
    'wgu-layerlist': LayerList
  },
  props: {
    icon: { type: String, required: false, default: 'md:layers' },
    showLegends: { type: Boolean, required: false, default: true },
    showOpacityControls: { type: Boolean, required: false, default: true },
    openAtLaunchLayers: { type: Array, required: false }
  }
};
</script>
